import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'
import zh from './zh.json'
import { deepFor } from '@/utils/utils.js'
// import { Model } from '@/model/goods/model.js'
// Model.initGoodsTypeList()
Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: 'zh',
	fallbackLocale: 'en',
	messages: { en, zh }
})
console.log('i18n ready')

const setMessage = (locale, newMessage) => {
	let oldMessage = i18n.getLocaleMessage(locale)
	deepFor(oldMessage, newMessage, (obj, key, value) => {obj[key] = value})
	i18n.setLocaleMessage(locale,oldMessage)
}

export { i18n, setMessage }